import { createReducer } from '@reduxjs/toolkit'

import { campaignTargetsTableColumnsConfig } from 'configuration/tables/targetsTable'
import {
    DATES,
    TARGET_STATES,
    METRIC_FILTERS,
    AD_GROUPS,
    AD_GROUP_STATES,
} from 'const/filters'
import { FILTER_SETTINGS, LOCAL_FILTERS } from 'const/reducerKeys'
import {
    ENABLED,
    STATE_FIELD_OPTIONS,
    TARGET_STATE_LABELS,
} from 'const/resourceStates'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [LOCAL_FILTERS]: {
        [AD_GROUPS]: [],
        [AD_GROUP_STATES]: [
            {
                value: ENABLED,
                label: STATE_FIELD_OPTIONS[ENABLED],
            },
        ],
        [TARGET_STATES]: [
            {
                value: ENABLED,
                label: TARGET_STATE_LABELS[ENABLED],
            },
        ],
        [METRIC_FILTERS]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES, AD_GROUPS, AD_GROUP_STATES],
        order: [TARGET_STATES, METRIC_FILTERS],
        displayState: {
            [TARGET_STATES]: true,
            [METRIC_FILTERS]: true,
        },
        userAdded: [AD_GROUP_STATES, TARGET_STATES],
    },
    table: getDefaultTable(serializeColumns(campaignTargetsTableColumnsConfig)),
}

export default createReducer(initialState, () => {})
